import { Card } from '@braze/web-sdk';
import React from 'react';
import ReactDOM from 'react-dom';
import { getBrazeInstance } from '../client';
import {
    DEFAULT_NOTIFICATION_TEMPLATE_ID,
    NOTIFICATION_TEMPLATES,
} from '../constants/notificationTemplates';
import { renderCustomNoCardsMessage } from './CustomBrazeNoCardsRenderer';
import { customizeDrawerHeader } from './DrawerHeader';
import './NotificationUIManager.css';

export function mountBrazeContentCardsUI(cards: Card[]): void {
    setTimeout(() => {
        customizeDrawerHeader();
        attachDrawerScrollListener();
        attachDrawerDismissHandler();

        if (!cards || cards.length === 0) {
            renderCustomNoCardsMessage();
            return;
        }

        const cardElements = document.querySelectorAll('.ab-card');
        cardElements.forEach((cardEl, index) => {
            applyCardTemplateStyles(cards[index], cardEl);
        });
    }, 50);
}

function applyCardTemplateStyles(card: Card, cardEl: Element): void {
    const templateIndex =
        Number(card?.extras?.template) || DEFAULT_NOTIFICATION_TEMPLATE_ID;

    const { color, icon: Icon } = NOTIFICATION_TEMPLATES[templateIndex];

    (cardEl as HTMLElement).style.setProperty('--card-accent-color', color);

    if (Icon && !cardEl.querySelector('.card-icon')) {
        const iconContainer = document.createElement('div');
        iconContainer.className = 'card-icon';

        ReactDOM.render(<Icon />, iconContainer);
        cardEl.prepend(iconContainer);
    }
}

function attachDrawerScrollListener(): void {
    const feed = document.querySelector('.ab-feed') as HTMLElement;
    if (!feed || feed.classList.contains('listener-attached')) return;

    const handleScroll = () => {
        const isScrolled =
            (document.body.scrollTop || document.documentElement.scrollTop) >
            10;
        feed.classList.toggle('scrolled', isScrolled);
    };

    const scrollContainer = document.querySelector('body');
    scrollContainer?.addEventListener('scroll', handleScroll);
    window.addEventListener('scroll', handleScroll); //for events option from side panel
    feed.classList.add('listener-attached');
    handleScroll();
}

function attachDrawerDismissHandler(): void {
    const drawer = document.querySelector('.ab-feed');
    if (!drawer) return;

    const handleClickOutside = async (event: MouseEvent) => {
        if (!drawer.contains(event.target as Node)) {
            const braze = await getBrazeInstance();
            braze.hideContentCards();
            document.removeEventListener('mousedown', handleClickOutside);
        }
    };

    document.addEventListener('mousedown', handleClickOutside);
}
